export interface BatchDataShortageUserListRequest {
  userRegistrationDateFrom: string
  userRegistrationDateTo: string
  userRegistrationBranchCode: string
  order: string
  userType: string
  checkShortageItems: []
  batchType: string
}

export function BatchDataShortageUserListRequestToJSON(
  value: BatchDataShortageUserListRequest
): any {
  return {
    user_registration_date_from: value.userRegistrationDateFrom,
    user_registration_date_to: value.userRegistrationDateTo,
    user_registration_branch_code: value.userRegistrationBranchCode,
    order: value.order,
    user_type: value.userType,
    check_shortage_items: value.checkShortageItems,
    batch_type: value.batchType
  }
}
